<!--Start : Tracking Search Input & Track Button-->
<div class="p-mt-5">
    <div>
        <div class="p-grid p-jc-between">
            <!--Input Search-->
            <div class="p-col-12 p-md-6 p-xl-3" *ngIf="!isTracked">
                    <span class="p-input-icon-right p-float-label width-100">
                        <input (input)="searchTrackingUsingTrackingId($event)" type="text" pInputText
                               (keyup.enter)="onClickOfTrack()"
                               class="width-100"/>
                        <label>Booking, Container, BL, AWBL</label>
						<i class="pi pi-search p-cursor" (click)="onClickOfTrack()"></i>
					</span>
            </div>
            <!--Tracking Id Preview button-->
            <div class="p-col-12 p-md-6 p-xl-4" *ngIf="isTracked">
                <div class="p-d-flex p-ai-center width-100">
                    <div class="p-text-secondary">
                        <h5 class="p-m-0" [class]="publicTracking ? 'tracking-id-label' : ''">Tracking ID</h5>
                    </div>
                    <div class="p-ml-1" style="width: 20vh">
                        <input style="height:4vh" type="text" class="width-100"
                               [class]="publicTracking ? 'landing-tracking-id-preview': ''" [(ngModel)]="trackingId"
                               pInputText
                               readonly>
                    </div>
                </div>
            </div>
            <!--Track Again & Track Button-->
            <div class="p-col-12 p-md-6 p-xl-5" *ngIf="isTracked">
                <div class="p-d-block p-d-md-flex p-ai-center p-jc-center p-jc-md-end width-100 p-text-center">
                    <div style="opacity: 0.4;">
                        <div class="p-m-0">Track New Shipment</div>
                    </div>
                    <div class="p-ml-0 p-ml-md-1 p-mt-1 p-mt-md-0 tracking-input-width">
                        <span class="p-float-label">
                            <input style="height:4vh" type="text" class="width-100" pInputText
                                   (input)="searchTrackingUsingTrackingId($event)">
                            <label>Booking, Container, BL, AWBL</label>
                        </span>
                    </div>
                    <div class="p-ml-0 p-ml-md-2 p-mt-1 p-mt-md-0">
                        <button type="button" pButton pRipple label="Track"
                                (click)="onClickOfTrack()"
                                [class]="publicTracking ? 'landing-track-button' : ''"
                                class="p-button-secondary"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--End : Tracking Search Input & Track Button-->

<!--Start: Tracking UI Preview without Search-->
<div class="card p-mt-2">

    <div class="p-py-2 divider-bottom">
        <h5 class="p-text-primary p-m-0">Shipment Tracking</h5>
    </div>

    <div [class]="!trackingDetails ? 'p-jc-center' : 'p-jc-start'">

        <!--        Start: Tracking Basic Details-->
        <div class="p-text-left" *ngIf="trackingDetails">
            <div class="basic-details-card">

                <div class="p-grid p-p-2 p-text-secondary">
                    <div class="p-col-6 p-md-3 p-xl-2"
                         *ngFor="let trackingHeader of trackingDetails?.trackingDetailsHeader | keyvalue: originalOrder">
                        <div>
                            <h6 class="p-my-1 p-text-secondary" style="min-width: max-content">
                                {{trackingHeader?.key ? trackingHeader?.key : 'NA'}}
                            </h6>
                        </div>
                        <div class="p-text-secondary">
                            {{trackingHeader?.value ? trackingHeader?.value : '-'}}
                        </div>
                    </div>
                </div>

                <!--                <div class="p-grid p-text-secondary \">-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2">-->

                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary" style="min-width: max-content">-->
                <!--                                Booking Number-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.bookingNumber ? trackingDetails?.shipmentTrackingVO?.bookingNumber : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType==='AIR' ||trackingDetails?.shipmentTrackingVO?.shipmentType=== 'Service Job'">-->

                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                ETD-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.departureDate ? (trackingDetails?.shipmentTrackingVO?.departureDate | date: 'yyyy-MM-dd') : ' - '}}-->
                <!--                        </div>-->

                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType==='AIR' ||trackingDetails?.shipmentTrackingVO?.shipmentType=== 'Service Job'">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                HAWB Number-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.hawbNumber ? trackingDetails?.shipmentTrackingVO?.hawbNumber : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType==='AIR'  ||trackingDetails?.shipmentTrackingVO?.shipmentType=== 'Service Job'">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                ETA-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.arrivalDate ? (trackingDetails?.shipmentTrackingVO?.arrivalDate | date: 'yyyy-MM-dd') : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType==='AIR'  ||trackingDetails?.shipmentTrackingVO?.shipmentType=== 'Service Job'">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary" style="min-width: max-content">-->
                <!--                                Gross Weight-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.grossWeight ? trackingDetails?.shipmentTrackingVO?.grossWeight : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType==='AIR'  ||trackingDetails?.shipmentTrackingVO?.shipmentType=== 'Service Job'">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary" style="min-width: max-content">-->
                <!--                                Flight No.-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.flightNumber ? trackingDetails?.shipmentTrackingVO?.flightNumber : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->

                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance'">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                HBL Number-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.hblNumber ? trackingDetails?.shipmentTrackingVO?.hblNumber : ' - ' }}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'AIR'  ||trackingDetails?.shipmentTrackingVO?.shipmentType=== 'Service Job' ">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary" style="min-width: max-content">-->
                <!--                                Customer Ref No.-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.customerReferenceNumber ? trackingDetails?.shipmentTrackingVO?.customerReferenceNumber : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' ">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                Vessel-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.vesselName ? trackingDetails?.shipmentTrackingVO?.vesselName : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' ">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                Voyage-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.voyage ? trackingDetails?.shipmentTrackingVO?.voyage : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'AIR'  || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Service Job'">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary" style="min-width: max-content">-->
                <!--                                Gross Weight-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.grossWeight ? trackingDetails?.trackingDetails?.shipmentTrackingVO : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'AIR'  || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Service Job'">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                Flight No.-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.flightNumber ? trackingDetails?.shipmentTrackingVO?.flightNumber : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' ">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                Place Of Receipt-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.placeOfReceipt ? trackingDetails?.shipmentTrackingVO?.placeOfReceipt : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' ">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                Port Of Loading-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.portOfLoading ? trackingDetails?.shipmentTrackingVO?.portOfLoading : ' - ' }}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' ">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                Port of Discharged-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.portOfDischarge ? trackingDetails?.shipmentTrackingVO?.portOfDischarge : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' ">-->

                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary p-text-secondary">-->
                <!--                                Final Place of delivery-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.finalPlaceOfDelivery ? trackingDetails?.shipmentTrackingVO?.finalPlaceOfDelivery : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'AIR' || trackingDetails?.shipmentTrackingVO?.shipmentType=== 'Service Job'">-->
                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary" style="min-width: max-content">-->
                <!--                                Transit Duration-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.transitDuration ? trackingDetails?.shipmentTrackingVO?.transitDuration + ' Days' : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                    <div class="p-col-6 p-md-3 p-xl-2"-->
                <!--                         *ngIf="trackingDetails?.shipmentTrackingVO?.shipmentType === 'FCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'LCL' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Transport' || trackingDetails?.shipmentTrackingVO?.shipmentType === 'Custom Clearance' ">-->

                <!--                        <div>-->
                <!--                            <h6 class="p-my-1 p-text-secondary">-->
                <!--                                No. of Containers-->
                <!--                            </h6>-->
                <!--                        </div>-->
                <!--                        <div class="p-text-secondary">-->
                <!--                            {{trackingDetails?.shipmentTrackingVO?.numberOfContainers ? trackingDetails?.shipmentTrackingVO?.numberOfContainers : ' - '}}-->
                <!--                        </div>-->
                <!--                    </div>-->

                <!--                </div>-->
            </div>
        </div>
    </div>
    <!--        End: Tracking Basic Details-->

    <!--            Start: Preview and Spinner-->
    <div *ngIf="!trackingDetails">

        <div class="p-d-flex p-ai-center p-jc-center"
             style="min-height: calc(93vh - 10.5rem)">
            <div class="p-pb-5">
                <div>
                    <div class="p-d-flex p-ai-center" *ngIf="!isLoading && !isError">
                        <div>
                            <i class="pi pi-exclamation-circle p-text-bold p-text-primary"></i>
                        </div>
                        <div class="p-ml-2">
                            <h5 class="p-m-0">
                                Please enter anyone of Booking, Container, BL, AWBL to Track Shipment
                            </h5>
                        </div>
                    </div>
                    <div class="p-text-center" *ngIf="isLoading">
                        <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 1.5rem;"></i>
                        <div class="p-pt-3 p-text-secondary">
                            Loading Tracking !
                        </div>
                    </div>

                    <div class="p-text-center" *ngIf="isError && !trackingDetails">
                        <i class="pi pi-exclamation-triangle p-text-bold p-text-secondary"
                           style="font-size: 4rem;"></i>
                        <div class="p-pt-3 p-text-secondary">
                            No Tracking Found !
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!--            End: Preview and Spinner-->

    <!--            Start: Tracking Details TimeLine-->
    <div *ngIf="trackingDetails">
        <div style="margin-top: 6vh;">
            <div class="p-grid p-jc-center">
                <div class="p-col-12 p-md-6 p-xl-4">
                    <p-timeline [value]="trackingDetailsArray" align="left"
                                styleClass="customized-timeline">
                        <ng-template pTemplate="marker" let-tracking>
                                    <span class="custom-marker">
                                        <img [src]="'assets/branding/shipment-tracking/' + tracking.icon + '.svg'"
                                             alt="N/A" width="50px">
                                    </span>
                        </ng-template>
                        <ng-template pTemplate="content" let-tracking>
                            <p-card class="timeline-tracking" [header]="tracking.status"
                                    [subheader]="tracking.statusDateTime ? tracking.statusDateTime: 'DD-MMM-YYYY 0:00 XX'">
<!--                                <p *ngIf="tracking?.showVoyage"-->
                                <!--                                   class="p-text-secondary">{{tracking?.vesselName ? tracking?.vesselName : 'N/A'}} |-->
                                <!--                                    {{tracking?.voyage ? tracking?.voyage : 'N/A'}}</p>-->
                            </p-card>
                        </ng-template>
                    </p-timeline>
                </div>
            </div>
        </div>
        <!--            End: Tracking Details TimeLine-->
    </div>

</div>
<!--End: Tracking UI Preview without Search-->
